import { render } from "./InvoiceFrequencyList.vue?vue&type=template&id=5086bc7c"
import script from "./InvoiceFrequencyList.vue?vue&type=script&lang=js"
export * from "./InvoiceFrequencyList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__